import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    // messy but you get the idea
    let isWhitespace = control.value != null && control.value != "" ? (control.value.toString() || '').trim().length === 0 : false;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': 'value is only whitespace' }

  };
}
